import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProjectsService } from '../../../../../../../../core/projects.service';

@Component({
    selector: 'app-external-test-details-expandable-block',
    templateUrl: './external-test-details-expandable-block.component.html',
    styleUrls: ['./external-test-details-expandable-block.component.scss'],
    standalone: false
})
export class ExternalTestDetailsExpandableBlockComponent implements OnInit, OnDestroy {
  @Input() icon = '';
  @Input() componentString = '';
  @Input() heading = '';
  @Input() data: any;
  @Input() itemCount: any = 0;
  @Input() isExpanded = false;
  @Input() isFirst = false;
  @Input() isLast = false;

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private projectsService: ProjectsService,
    private cdRef: ChangeDetectorRef,
  ) {
  }

  ngOnInit() {
    this.projectsService.changeView
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.data.externalTestDetails = {};
        if (data?.id) {
          this.data.externalTestDetails = data;
        }
        this.cdRef.detectChanges();
      });
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
